export const plans = {
  trial: {
    label: "Essai gratuit",
    features: {
      maxRessources: 2,
      projects: true,
      cash: true,
      ideas: true,
      reminders: true,
    }
  },
  free: {
    label: "Gratuit",
    features: {
      maxRessources: 2,
      projects: false,
      cash: false,
      ideas: false,
    }
  },
  basic: {
    label: "Basique",
    features: {
      planning: true,
      projects: true,
      cash: true,
      ideas: true,
      ressources: true,
      clients: true,
    }
  },
  premium: {
    label: "Premium",
    features: {
      planning: true,
      projects: true,
      cash: true,
      ideas: true,
      ressources: true,
      clients: true,
    }
  },
  best: {
    label: "Meilleur",
    features: {
      maxRessources: 25,
      users: true,
      projects: true,
      cash: true,
      ideas: true,
      reminders: true,
    }
  },
}

import { auth, db } from '@/firebase'
import { doc, getDoc } from 'firebase/firestore'

let cachedFeatures = null;
let cachedUid = null;

export async function getPlanFeatures() {
  const user = auth.currentUser;
  if (!user) return {};
  if (cachedFeatures && cachedUid === user.uid) {
    return cachedFeatures;
  }
  const userDoc = await getDoc(doc(db, "users", user.uid));
  const planName = userDoc.exists() ? userDoc.data().plan || '' : '';
  cachedFeatures = plans[planName]?.features || {};
  cachedUid = user.uid;
  return cachedFeatures;
}

// Ajoute une fonction pour forcer le rafraîchissement si besoin
export function clearPlanFeaturesCache() {
  cachedFeatures = null;
  cachedUid = null;
}

export async function getPlanName() {
  const user = auth.currentUser
  if (!user) return 'trial'
  const userDoc = await getDoc(doc(db, "users", user.uid))
  return userDoc.exists() ? userDoc.data().plan || '' : ''
}
